module.exports = __webpack_public_path__ + "admin-user.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/admin-user.svg
// module id = 45qS
// module chunks = 0